import { Box, styled } from '@mui/material';

// Fondo de TODAS las pantallas públicas de auth: gradiente off-black mode-aware
// (token authBackdrop) en lugar de la foto a pantalla completa. Centra el card.
// En mobile alinea el card ARRIBA con espacio suficiente para que sus tabs
// ("Crear cuenta") no choquen con los controles de tema/idioma del top-right.
const StyledAuthBackdrop = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  background: theme.palette.authBackdrop,
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100dvh',
  paddingBottom: theme.spacing(2.5),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  // Despeja los 16px + ~40px de los controles del top-right.
  paddingTop: theme.spacing(9),
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    padding: theme.spacing(6)
  }
}));

export default StyledAuthBackdrop;
